import axios from 'axios';
import Clipboard from 'clipboard';
import 'babel-polyfill';
import { md5 } from '../lib/md5.js';
import { reject } from 'lodash-es';
var loadingImg = require('../../img/loading.gif');
/**
 * 通用类
 */
var common = {
  getQueryString: function () {
    // 获取url中"?"符后的字串
    var url = location.search;
    var theRequest = new Object();
    if (url.indexOf('?') != -1) {
      var str = url.substr(1);
      var strs = str.split('&');
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1]);
      }
    }
    return theRequest || {};
  },
  downloadIamge: function (imgsrc, name) {
    // 处理IE无法使用toBlob方法
    if (!HTMLCanvasElement.prototype.toBlob) {
      Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
        value: function (callback, type, quality) {
          var canvas = this;
          setTimeout(function () {
            var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]);
            var len = binStr.length;
            var arr = new Uint8Array(len);

            for (var i = 0; i < len; i++) {
              arr[i] = binStr.charCodeAt(i);
            }

            callback(new Blob([arr], { type: type || 'image/png' }));
          });
        }
      });
    }
    //下载图片地址和图片名
    let image = new Image();
    // 解决跨域 Canvas 污染问题
    image.setAttribute('crossOrigin', 'anonymous');
    image.onload = function () {
      let canvas = document.createElement('canvas');
      canvas.width = image.width;
      canvas.height = image.height;
      let context = canvas.getContext('2d');
      context.drawImage(image, 0, 0, image.width, image.height);
      canvas.toBlob(function (blobObj) {
        let imgSrc = window.URL.createObjectURL(blobObj);
        // IE下载
        var data = new Blob([blobObj]);
        if (navigator.msSaveOrOpenBlob) {
          navigator.msSaveOrOpenBlob(data, name + '.jpg');
        } else {
          let a = document.createElement('a'); // 生成一个a元素
          a.setAttribute('download', name || 'photo');
          a.id = 'imgClick';
          document.body.appendChild(a);
          a.href = imgSrc; // 将生成的URL设置为a.href属性
          a.click();
          a.remove();
        }
      });
    };
    image.src = imgsrc;
  },
  /**
   * 字母、汉字或者汉字字母组合
   */
  checkChineseAndLetters: function (value) {
    let reg = /^[a-zA-Z（）()\u4e00-\u9fa5]+$/;
    if (reg.test(value)) {
      return { flag: true };
    }
    return { flag: false, error: '只能输入字母、汉字或者字母汉字组合' };
  },
  /**
   * 金额千分位
   * @num 数字
   * @floorLength 小数位数
   */
  moneyToThousands: function (num, floorLength) {
    if (!num) {
      return '';
    }
    num = String(num);
    if (num == undefined || num == 'undefined') {
      return num;
    }
    var numArr = num.split('.');
    var str = numArr[0];
    var firstChar = '';
    for (var i = 0; i < Math.floor((str.length - (1 + i)) / 3); i++) {
      firstChar = str.substring(0, str.length - (4 * i + 3));
      if (String(firstChar).length == 1 && !/^[0-9]*$/g.test(firstChar)) {
        str = firstChar + str.substring(str.length - (4 * i + 3));
      } else {
        str = firstChar + ',' + str.substring(str.length - (4 * i + 3));
      }
    }
    // 有小数
    if (numArr[1]) {
      return str + '.' + numArr[1];
    }
    // 无小数
    else {
      if (floorLength) {
        str = str + '.';
        for (var i = 0; i < floorLength; i++) {
          str = str + '0';
        }
        return str;
      }
      return str;
    }
  },
  /**
   * 金额验证
   * @value 值
   * @length 小数点后保留的位数
   * @max   最大整数的位数
   * @decText 错误描述文字
   * @maxCallback 最大值处理
   * @notValidateZero 不验证0
   */
  checkMoney: (value, length, max, decText, maxCallback, notValidateZero) => {
    let dec = decText || '金额';
    value += '';
    value = value.toString();
    var checkLength = length + 1;
    var p1 = /[^\d\.]/; // 过滤非数字及小数点 /g :所有范围中过滤
    var p2 = /(\.\d{3})\d*$/;
    if (length == 4) {
      p2 = /(\.\d{5})\d*$/;
    }
    if (length == 6) {
      p2 = /(\.\d{7})\d*$/;
    }
    if (length == 10) {
      p2 = /(\.\d{11})\d*$/;
    }
    if (length == 12) {
      p2 = /(\.\d{13})\d*$/;
    }
    var p3 = /(\.)(\d*)\1/;
    var p4 = /\.+/; //多个点的话只取1个点，屏蔽1....234的情况
    var p5 = /(\.+)(\d+)(\.+)/; //屏蔽1....234.的情况

    if (p1.test(value)) {
      return {
        flag: false,
        error: dec + '只能包含数字和小数点！'
      };
    }
    if (
      (value.indexOf('.') != -1 && value.indexOf('.') == 0) ||
      (value.lastIndexOf('.') != -1 &&
        value.lastIndexOf('.') == value.length - 1)
    ) {
      return {
        flag: false,
        error: '第一位和最后一位不能是小数点！'
      };
    }
    if (p2.test(value)) {
      return {
        flag: false,
        error: '小数点后最多输入' + length + '位！'
      };
    }
    if (p3.test(value)) {
      return {
        flag: false,
        error: '只能有一个小数点！'
      };
    }
    if (p5.test(value)) {
      return {
        flag: false,
        error: dec + '格式输入有误！'
      };
    }
    if (maxCallback && maxCallback instanceof Function) {
      return maxCallback();
    } else {
      if (!notValidateZero && value <= 0) {
        return {
          flag: false,
          error: dec + '必须大于0！'
        };
      }
      if (max && value.split('.')[0].length > max) {
        return {
          flag: false,
          error: dec + '整数不能超过' + max + '位！'
        };
      }
    }
    return {
      flag: true
    };
  },
  /**
   * 获取当前日期
   */
  getNowDate: function () {
    let symbol = '-';
    let date = new Date();
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let strDate = date
      .getDate()
      .toString()
      .padStart(2, '0');
    return year + symbol + month + symbol + strDate;
  },
  /*
   **将日期对象转化为yyyy-mm-dd
   */
  dateFormat: date => {
    var a = typeof date;
    if (date != null && date != '' && date != undefined && a == 'object') {
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      if (month >= 1 && month <= 9) {
        month = '0' + month;
      }
      if (day >= 0 && day <= 9) {
        day = '0' + day;
      }
      return year + '-' + month + '-' + day;
    } else {
      return date;
    }
  },
  /**
   * 时间差
   */
  timeDifference: function (date1, date2) {
    var date1 = new Date(date1); //开始时间
    var date2 = new Date(date2); //结束时间
    var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
    //计算出相差天数
    var days = Math.floor(date3 / (24 * 3600 * 1000));
    //计算出小时数
    var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
    var minutes = Math.floor(leave2 / (60 * 1000));
    //计算相差秒数
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
    var seconds = Math.round(leave3 / 1000);
    return { days: days, hours: hours, minutes: minutes, seconds: seconds };
  },
  /**
   * 日期减去天数
   */
  AddDayToDate: function (Time, days) {
    var a = new Date(Time);
    a = a.valueOf();
    a = a - days * 24 * 60 * 60 * 1000;
    a = new Date(a);

    return common.dateFormat(new Date(a));
  },
  /**
   * 日期格式为：yyyy-mm-dd
   * 显示的日期格式
   */
  getDateTextFormat: function (dateStr) {
    if (dateStr) {
      return dateStr.substr(0, 10);
    }
    return dateStr;
  },
  /**
   * 比较字符串格式日期大小
   */
  compareDate: function (checkStartDate, checkEndDate) {
    var arys1 = new Array();
    var arys2 = new Array();
    if (checkStartDate != null && checkEndDate != null) {
      arys1 = checkStartDate.split('-');
      var sdate = new Date(arys1[0], parseInt(arys1[1] - 1), arys1[2]);
      arys2 = checkEndDate.split('-');
      var edate = new Date(arys2[0], parseInt(arys2[1] - 1), arys2[2]);
      if (sdate > edate) {
        return false;
      } else {
        return true;
      }
    }
  },
  /**
   * 获取相关资讯
   * @page {当前页数} params
   * @rowsPerPage {每页条数} params
   * @classifyName {类目名称} params
   * @callback  {成功回调} params
   */
  getNewsList: function (params) {
    ajax.request({
      method: 'GET',
      url: '/info/app/ext/newsList.action',
      params: {
        page: params.page,
        rowsPerPage: params.rowsPerPage,
        classifyId: params.classifyName,
        containFlag: '123123'
      },
      successCallback: function (data) {
        params.callback(data);
      }
    });
  }
};
/**
 * 加载类
 */
var loadingClass = {
  loadingStart: function () {
    $('html').append('<div class="loading-box"><img src=""></div>');
    $('.loading-box img').attr('src', loadingImg);
  },
  loadingEnd: function () {
    $('.loading-box').remove();
  }
};
/**
 * 校验金额类
 */
var checkClass = {
  /**
   * 金额验证
   * @value 值
   * @length 小数点后保留的位数
   * @max   最大整数的位数
   * @maxCallback 最大值处理
   * @notValidateZero 不验证0
   * @negative 是否有负号
   */
  checkMoney: (value, length, max, maxCallback, notValidateZero, negative) => {
    value += '';
    value = value.toString();
    if (negative) {
      var num = value.charAt(0);
      if (num == '-') {
        value = value.slice(1, value.length);
      }
    }
    var checkLength = length + 1;
    var p0 = /[^\d]/;
    var p1 = /[^\d\.]/; // 过滤非数字及小数点 /g :所有范围中过滤
    var p2 = /(\.\d{3})\d*$/;
    if (length == 4) {
      p2 = /(\.\d{5})\d*$/;
    }
    if (length == 6) {
      p2 = /(\.\d{7})\d*$/;
    }
    if (length == 10) {
      p2 = /(\.\d{11})\d*$/;
    }
    if (length == 12) {
      p2 = /(\.\d{13})\d*$/;
    }
    var p3 = /(\.)(\d*)\1/;
    var p4 = /\.+/; //多个点的话只取1个点，屏蔽1....234的情况
    var p5 = /(\.+)(\d+)(\.+)/; //屏蔽1....234.的情况
    if (length == 0 && p0.test(value)) {
      return {
        flag: false,
        error: '只能包含数字！'
      };
    }
    if (p1.test(value)) {
      return { flag: false, error: '只能包含数字和小数点' };
    }
    if (
      (value.indexOf('.') != -1 && value.indexOf('.') == 0) ||
      (value.lastIndexOf('.') != -1 &&
        value.lastIndexOf('.') == value.length - 1)
    ) {
      return { flag: false, error: '小数点前后需有数字' };
    }
    if (p2.test(value)) {
      return { flag: false, error: '小数点后最多' + length + '位数字' };
    }
    if (p3.test(value)) {
      return { flag: false, error: '只能有一个小数点' };
    }
    if (p5.test(value)) {
      return { flag: false, error: '金额格式输入有误' };
    }
    if (maxCallback) {
      return maxCallback();
    } else {
      if (!notValidateZero && value <= 0) {
        return { flag: false, error: '金额必须大于0' };
      }
      if (value.split('.')[0].length > max) {
        return { flag: false, error: '整数不能超过' + max + '位' };
      }
    }
    return { flag: true };
  }
};
/**
 * 缓存类
 */
var cacheClass = {
  setCache: function (data) {
    localStorage.setItem('babfu-info', JSON.stringify(data));
    if (!localStorage.getItem('isBindPhonePrompt')) {
      localStorage.setItem('isBindPhonePrompt', JSON.stringify([]));
    }
    let list = JSON.parse(localStorage.getItem('isBindPhonePrompt'));
    let flag = true;
    for (let item of list) {
      if (item.userPhone == data.phone) flag = false;
    }
    if (flag) {
      let info = {
        userPhone: data.phone,
        flag: false
      };
      list.push(info);
      localStorage.setItem('isBindPhonePrompt', JSON.stringify(list));
    }
  },
  getCache: function () {
    var loginInfo = localStorage.getItem('babfu-info');
    return loginInfo || null;
  },
  deleteAllCache: function () {
    localStorage.removeItem('babfu-info');
  },
  Cookie: {
    set: function (name, value) {
      var d = new Date();
      d.setTime(d.getTime() + 1 * 60 * 60 * 1000); // 60分钟过期
      window.document.cookie =
        name + '=' + value + ';path=/;expires=' + d.toGMTString();
    },

    get: function (name) {
      var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
      return v ? v[2] : null;
    },
    delete: function (name) {
      this.set(name, '', -1);
    }
  }
};
/**
 * 控制类
 */
var controlClass = {
  /**
   * 剪贴板方法
   * @buttonId 按钮对象
   */
  clipboard: function (buttonId) {
    if (buttonId) {
      let clipboard = new Clipboard(buttonId);
      clipboard.on('success', function (e) {
        messageBox.show('已复制到剪贴板');
      });
      clipboard.on('error', function (e) {
        messageBox.show('复制失败');
      });
    }
  },
  // 获取url参数值
  getQueryString: function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
      return unescape(r[2]);
    }
    return '';
  }
};
/**
 * 弹框提示
 */
var messageBox = {
  show: function (msg) {
    let div = document.createElement('div');
    div.innerText = msg;
    div.classList.add('message-box');
    $('html').append(div);
    setTimeout(() => {
      $(div).hide();
    }, 3000);
  }
};
/**
 * 请求类
 */
var ajax = {
  /**
   *通用的ajax异常回调处理
   *@response ajax异常返回的数据
   *@errorCallback 错误回调函数
   *@isNotErrorPropmt 是否不需要错误提示
   */
  error_resp: function (response, errorCallback, isNotErrorPropmt) {
    if (!response) {
      !isNotErrorPropmt && messageBox.show('系统错误，请联系相关人员！');
      if (errorCallback instanceof Function) {
        errorCallback && errorCallback(response);
      }
    } else {
      // 登录超时
      if (response.code == '010004' || response.code == '990010') {
        if (response.code == '010004') {
          messageBox.show('登录超时，请重新登录');
        } else {
          messageBox.show(response.msg);
        }
        cacheClass.deleteAllCache();
        cacheClass.Cookie.delete('username');
        // loading结束
        loadingClass.loadingEnd();
        setTimeout(() => {
          window.location.href = '/view/login/index.html';
        }, 1500);
      }
      // 当版本号错误时，需要做的处理
      else if (response.code == '990001') {
        messageBox.show('数据已被更新，请重新刷新列表数据');
        if (errorCallback instanceof Function) {
          errorCallback && errorCallback(response);
        }
      } else if (response.code == '999996') {
        //无授权小程序时 不进行操作
        errorCallback && errorCallback(response);
      } else {
        var errorMsg = response.msg || '系统错误，请联系相关人员！';
        if (errorCallback instanceof Function) {
          errorCallback && errorCallback(response);
          !isNotErrorPropmt && messageBox.show(errorMsg);
        } else {
          !isNotErrorPropmt && messageBox.show(errorMsg);
        }
      }
    }
    // loading结束
    loadingClass.loadingEnd();
  },
  /**
   *通用的ajax成功回调处理
   *@response ajax成功返回的数据
   *@successCallback 成功回调函数
   *@errorCallback 错误的回调函数
   *@isNotErrorPropmt 是否不显示错误信息true:不显示
   */
  success_resp: function (
    response,
    successCallback,
    errorCallback,
    isNotErrorPropmt
  ) {
    if (!response) {
      messageBox.show('系统错误,请联系相关人员！');
      if (errorCallback instanceof Function) {
        errorCallback && errorCallback(response);
      }
    } else if (response.code == '000000') {

      if (successCallback instanceof Function) {
        successCallback && successCallback(response.data, response);
      }
    }
    // 资讯特殊处理
    else if (response.newsRecords || response.newRecord) {
      if (successCallback instanceof Function) {
        successCallback &&
          successCallback(response.newsRecords || response.newRecord);
      }
    } else {
      // 调用错误的通用回调
      ajax.error_resp(response, errorCallback, isNotErrorPropmt);
    }
    // loading结束
    loadingClass.loadingEnd();
  },
  /**
   * 发送请求方法
   * @requestConfig 设置请求对象
   *   @method 访问类型
   *   @url api地址
   *   @params 请求连接中的请求参数,url参数
   *   @data 请求提需要设置的数据
   *   @successCallback 成功的回调函数
   *   @errorCallback 错误的回调函数
   *   @isNotErrorPropmt 是否不显示错误信息true:不显示
   */
  request: function (requestConfig) {
    console.log(requestConfig, 'responseType')
    if (requestConfig.isNeedLoading !== false) loadingClass.loadingStart();
    if (requestConfig.method == 'GET') {
      for (let key in requestConfig.params) {
        requestConfig.params[key] =
          typeof requestConfig.params[key] === 'string'
            ? requestConfig.params[key].replace(/\s+/g, '')
            : requestConfig.params[key];
      }
    }
    axios({
      method: requestConfig.method,
      url: requestConfig.url + '?source=web',
      baseURL: '/api/', // 请求前缀【需转发】
      //`headers`是自定义的要被发送的头信息
      headers: {
        'Auth-Token': md5StrFn(
          requestConfig.method == 'GET'
            ? requestConfig.params
            : requestConfig.data,
          {
            method: requestConfig.method
          }
        ),
        'Content-Type':
          requestConfig.method != 'GET'
            ? 'application/json'
            : 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      // `params`是请求连接中的请求参数，必须是一个纯对象，或者URLSearchParams对象
      params: requestConfig.params,
      // `data`是请求提需要设置的数据
      data: requestConfig.data,
      // 如果请求的时间超过这个设定时间，请求将会停止
      timeout: 60000,
      // `responsetype`表明服务器返回的数据类型，这些类型的设置应该是
      // 'arraybuffer','blob','document','json','text',stream'
      responsetype: requestConfig.responseType || 'blob'
    })
      .then(function (response) {
        var data = response.data || response;
        ajax.success_resp(
          data,
          requestConfig.successCallback,
          requestConfig.errorCallback,
          requestConfig.isNotErrorPropmt
        );
      })
      .catch(function (error) {
        if (error.response) {
          //存在请求，但是服务器的返回一个状态码
          //他们都在2xx之外
          ajax.error_resp(
            error.response.data,
            requestConfig.errorCallback,
            requestConfig.isNotErrorPropmt
          );
        } else {
          //一些错误是在设置请求时触发的
          // console.log("Error", error.message);
        }
        // console.log(error.config);
      });
  }
};
/**
 * 参数加密
 */
function md5StrFn(oldParams, config) {
  const endStr = '6Q3WJqGnoSMtQulXMWQ';

  let params = {};
  for (let key in oldParams) {
    params[key] = oldParams[key];
  }
  let dataType = config.method || 'GET';
  let resStr = '';
  if (dataType == 'GET') {
    params.source = 'web';
    for (let key in params) {
      resStr += key + '=' + params[key] + '&';
    }
    if (resStr) {
      resStr = resStr.substring(0, resStr.length - 1);
    }
    resStr = resStr.replace(/\s+/g, '');
    resStr = encodeURI(resStr);
  } else {
    resStr = JSON.stringify(params);
    // 去空格
    resStr = resStr.replace(/\s+/g, '');
  }

  // 字符串升序 md5 加密
  let resMd5 = md5(
    Array.from(resStr)
      .sort()
      .join('') + endStr
  );
  // console.log(Array.from(resStr).sort().join("") + endStr)
  // console.log(`原：${resStr}   新：${resMd5}`)
  return resMd5.toLowerCase();
}
function ajaxPDF(configOptions) {
  return new Promise((reslove, reject) => {
    axios({
      method: configOptions.method || 'GET',
      url: configOptions.url,
      baseURL: '/api/', // 请求前缀【需转发】
      //`headers`是自定义的要被发送的头信息
      data: configOptions.data,
      // 如果请求的时间超过这个设定时间，请求将会停止
      timeout: 60000,
      // `responsetype`表明服务器返回的数据类型，这些类型的设置应该是
      // 'arraybuffer','blob','document','json','text',stream'
      responseType: 'blob'
    }).then(function (res) {
      reslove(res);
    }).catch(function (err) {
      reject(err)
    })
  })
}

function createPDFURL(data) {
  let url = null
  let file = new Blob([data], { type: 'application/pdf;chartset=UTF-8' })
  if (window.createObjectURL != undefined) {
    // 通用
    url = window.createObjectURL(file)
  } else if (window.webkitURL != undefined) {
    // 兼容谷歌
    try {
      url = window.webkitURL.createObjectURL(file)
    } catch (error) {

    }
  } else if (window.URL != undefined) {
    // 兼容其他
    try {
      url = window.URL.createObjectURL(file)
    } catch (error) {

    }
  }

  return url
}
export {
  common,
  loadingClass,
  cacheClass,
  ajax,
  controlClass,
  messageBox,
  checkClass,
  md5StrFn,
  ajaxPDF,
  createPDFURL
};

$(function () {
  /**
   * 头部导航栏选中事件
   */
  $('.nav-box')
    .children()
    .removeClass('active');
  var pathname = window.location.pathname;
  // 当前页面路由
  var pageName = pathname.split('/')[2];
  // 个人中心特殊处理
  if (pageName && pageName.indexOf('personalCenter') > -1) {
    $('.personalCenter' + '-nav').addClass('active');
  }
  // 其它路由
  else if (pageName) {
    $('.' + pageName + '-nav').addClass('active');
  }
  // 首页没有路由
  else {
    $('.index-nav').addClass('active');
  }
  /**
   * 判断当前登录状态，导航栏状态改变
   */

  var loginInfo = JSON.parse(cacheClass.getCache());
  var loginStatus = cacheClass.Cookie.get('username');
  if (loginStatus && loginInfo) {
    $('.login-out').hide();
    $('.login-in')[0].style.visibility = 'visible';
    $('.login-in')[0].style.height = '60px';
    $('.login-box').hide();
    $('.banner-info')
      .addClass('login')
      .show();
    $('.electronicRetailing-wrapper .banner-info').removeClass('login');
    // 网商询价-企业名称
    $('.wangShang-price .search-box .input-mark.panyName').show();
    //网商秒贴-贴现提额
    $('.electronicRetailing-wrapper .discount-btn').show();
    // 个人中心头像
    let htemePicHost = location.host.includes('babfu')
      ? 'https://bms.babfu.com/'
      : 'https://gotten-test.oss-cn-shanghai.aliyuncs.com/';
    if (loginInfo.themePic) {
      $('.login-head #upload').attr('src', htemePicHost + loginInfo.themePic);
    }
  } else {
    if (location.href.includes('personal')) {
      location.href = '/view/login/index.html';
    }
    $('.login-out')[0].style.visibility = 'visible';
    $('.login-in').hide();
    $('.login-box').show();
    $('.banner-info')
      .removeClass('login')
      .show();
    $('.wangShang-price .search-box .input-mark.panyName').hide();
    //网商秒贴-贴现提额
    $('.electronicRetailing-wrapper .discount-btn').hide();
  }

  // 退出登录
  $('.login-in').hover(
    function () {
      $('.login-out-btn').css('visibility', 'visible');
    },
    function () {
      $('.login-out-btn').css('visibility', 'hidden');
    }
  );
  $('.login-out-btn').click(function () {
    if (JSON.parse(cacheClass.getCache())) {
      ajax.request({
        method: 'POST',
        url: '/app/logout',
        data: {
          userName: JSON.parse(cacheClass.getCache()).userName
        },
        successCallback: function (data) {
          cacheClass.deleteAllCache();
          cacheClass.Cookie.delete('username');
          location.href = '/';
        }
      });
    } else {
      location.href = '/';
    }
  });
  /**用户中心菜单权限 */
  let agentAuth = JSON.parse(cacheClass.getCache());
  if (agentAuth && agentAuth.agentName == 'null') {
    $('#agentAuth')
      .parent()
      .parent()
      .remove();
  } else {
    $('#agentAuth')
      .parent()
      .parent()
      .show();
  }
});



// WEBPACK FOOTER //
// ./src/js/common/common.js